module.exports = __webpack_public_path__ + "static/media/ic_verygood.798c1990.png";